const EXAMPLE_MAP = {
  'offer.car.segmento': [
    {
      value: 'A',
      conditions: [['offer.duration', '<=', 42]],
      multipliedBy: 1,
    },
    {
      value: 'A',
      conditions: [['offer.duration', '>', 42]],
      multipliedBy: 1,
    },
    {
      value: 'B',
      conditions: [['offer.duration', '<=', 42]],
      multipliedBy: 1.333,
    },
    {
      value: 'B',
      conditions: [['offer.duration', '>', 42]],
      multipliedBy: 1,
    },
  ],
};

export const getPriceFromMap = (price, priceMap, selectedOffer) => {
  let result = price;

  for (const dependencyPath in priceMap) {
    const found = dependencyElementExists(dependencyPath, selectedOffer);
    const dependencies = priceMap[dependencyPath]
      .filter(dep => dep.value == found)
      .filter(dep =>
        dep.conditions.every(condition => {
          const [conditionPath, conditionOperator, conditionValue] = condition;
          const conditionFound = dependencyElementExists(
            conditionPath,
            selectedOffer,
          );
          return evaluateCondition(
            `${conditionFound} ${conditionOperator} ${conditionValue}`,
          );
        }),
      );

    if (found && dependencies.length) {
      result *= dependencies[0].multipliedBy;
    }
  }

  return Math.round(result);
};

const evaluateCondition = evalString => new Function(`'use strict'; return (${evalString})`)();

const dependencyElementExists = (dependencyPath, selectedOffer) => {
  const keys = dependencyPath.split('.');
  let data = selectedOffer;

  for (const key of keys) {
    data = data[key];

    if (data === undefined) {
      return undefined;
    }
  }

  return data;
};
